<template>
  <span>
    <input type="date" v-model="d1" v-focus @change="d1Change"/>
    <span v-if="showRange || alwaysRange">
      - <input type="date" v-model="d2" @change="d2Change"/>
    </span>
    <span v-if="!alwaysRange">
      Range <input type="checkbox" id="dateRangeCheckbox" v-model="showRange" @change="rangeChange"/>
    </span>

  </span>
</template>        

<script>

export default {

  props: {
    container: null,
    dateProp: null,
    alwaysRange: false
  },

  data () {
    return { 
      d1: null,
      d2: null,
      showRange: false
    }
  },

  watch: {  
  },

  async created () {
    console.log("IN EditDateMaybeRange, date= " + JSON.stringify(this.container[this.dateProp])) ;
    const source = this.container[this.dateProp] ;
    if (!source) {
      this.showRange = false ;
      this.d1 = null ;
      this.d2 = null ;
    }
    else {
      const i = source.indexOf(" - ") ;
      if (i > 0) {
        this.d1 = source.substring(0, i) ;
        this.d2 = source.substring(i + 3) ;
        this.showRange = true ;
      }
      else {
        this.d1 = source ;
        this.d2 = null ;
        this.showRange = false ;
      }
    }
    // this.d1 = this.container[this.dateProp] ;
  },

  methods: {
    d1Change () {
      console.log(this.dateProp + " d1 change, d1 = " + this.d1) ;
      if (this.showRange && this.d2) {
        this.container[this.dateProp] = this.d1 + " - " + this.d2 ;
        if (this.container === " - ") this.container = "" ;
      }
      else this.container[this.dateProp] = this.d1 ;
    },
    d2Change () {
      console.log(this.dateProp + " d2 change, d2 = " + this.d2) ;
      this.container[this.dateProp] = this.d1 + " - " + this.d2 ;
      if (this.container === " - ") this.container = "" ;
    },
    rangeChange () {
      console.log(this.dateProp + " range change now " + this.showRange) ;
      if (this.showRange) this.d2 = this.d1 ;
      this.d1Change() ;
    }

  } 
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Person/EditDateMaybeRange.vue